
<template>
    <div class="yuji-news" :class="device == 'mobile' ? 'yuji-news-mobile' : ''">
        <div class="news padding-top">
            <div class="main">
                <div class="tags">
                    <a href="/index">首页</a>
                    >
                    <a href="/news">新闻中心</a>
                    >
                    <span>新闻详情</span>
                </div>
                <div class="news-box">
                    <h2 class="title">体验未来：虚拟AI聊天</h2>
                    <div class="time">2023-09-15 11:00:10</div>
                    <div class="start">
                        在这个数字化的时代，人工智能技术正逐步渗透到我们的生活的各个方面，其中之一就是虚拟AI聊天。虚拟AI聊天是一种通过AI技术实现的聊天方式，可以实现与人类的自然、智能的对话。目前，虚拟AI聊天已经广泛应用于客服、社交、娱乐、教育等多个领域，为我们的生活带来了极大的便利。
                    </div>
                    <div class="banner">
                        <img src="@/assets/imgs/news/237.png" alt="体验未来：虚拟AI聊天" srcset />
                    </div>
                    <div class="list">
                        <div class="list-t">
                        </div>
                        <div class="list-text">

                            首先，虚拟AI聊天可以提升客服的服务质量。在传统的客服模式中，客服人员往往需要处理大量的咨询、投诉等，可能会因为人为因素，比如疲劳、情绪等，导致服务质量不稳定。而虚拟AI聊天可以实现全天候的在线服务，可以根据用户的提问快速、准确的给出答案，而且可以根据用户的情绪、历史记录等，提供更加人性化的服务。
                        </div>

                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            其次，虚拟AI聊天可以实现更加智能化的社交。在传统的社交方式中，我们往往需要花费大量的时间和精力去维护人际关系。而虚拟AI聊天可以帮助我们更加高效的进行社交。例如，它可以帮助我们分析朋友的兴趣爱好、情绪状态等，然后给出合适的聊天建议。此外，虚拟AI聊天还可以帮助我们自动回复一些常见的消息，从而节省我们的时间和精力。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            再次，虚拟AI聊天可以实现更加多元化的娱乐。在传统的娱乐方式中，我们通常需要找到合适的对象进行互动，而虚拟AI聊天可以随时随地的为我们提供娱乐。例如，它可以根据我们的喜好、情绪等，推荐适合的音乐、影视、游戏等。此外，虚拟AI聊天还可以通过对话、角色扮演等方式，为我们提供更加丰富的娱乐体验。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            虽然虚拟AI聊天有很多优势，但也存在一些局限性。例如，目前的技术还无法完全理解人类的情绪、语言、文化等，可能会出现误解、冲突等情况。因此，我们需要在使用虚拟AI聊天时，保持一定的警惕性，避免过分依赖。
                        </div>
                    </div>

                    <div class="end">
                        总的来说，虚拟AI聊天作为一种先进的技术，具有提升服务质量、实现智能化社交、多元化娱乐等多方面的优势，是未来聊天的发展趋势。但同时，我们也需要看到它的局限性，合理的利用虚拟AI聊天，提升我们的生活质量。

                    </div>
                </div>
                <a href="/index" class="btn">
                    了解更多
                    <img src="@/assets/imgs/index/arrow.png" alt />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/header";
import newsData from "@/utils/newJson";
export default {
    components: {
        Header,
    },
    computed: {
        device() {
            return this.$store.state.app.device;
        },
    },
    metaInfo: {
        title: "体验未来：虚拟AI聊天-羽迹美形", // set a title
        meta: [
            {
                // set meta
                name: "keyWords",
                content: "体验未来：虚拟AI聊天,羽迹美形",
            },
            {
                // set meta
                name: "description",
                content:
                    "在这个数字化的时代，人工智能技术正逐步渗透到我们的生活的各个方面，其中之一就是虚拟AI聊天",
            },
        ],
    },
    data() {
        return {
            path: "newsInfo3",
            obj: {},
        };
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        var index = this.$route.params.index;
        newsData.forEach((el, i) => {
            if (el.index == index) {
                this.obj = el;
            }
        });
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
    },
};
</script>


<style lang="scss" scoped>
.yuji-news {
    .news {
        min-width: 720px;

        .main {
            .tags {
                height: 40px;
                line-height: 40px;
                color: #999;
                border-bottom: 1px solid #eee;
                font-size: 14px;

                a {
                    color: #999;
                }
            }

            width: 720px;

            .back {
                height: 50px;
                line-height: 50px;
                position: relative;
                padding-left: 20px;
                cursor: pointer;
                border-bottom: 1px solid #eee;
                width: 720px;
                background: #fff;

                &::before {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    content: "";
                    width: 6px;
                    height: 6px;
                    border-left: 2px solid #666;
                    border-bottom: 2px solid #666;
                    transform: rotate(45deg) translateY(-50%);
                }

                span {
                    color: #666;
                    font-size: 14px;
                }
            }

            .news-box {
                // padding: 100px 0;
                // display: flex;
                // justify-content: center;
                // background: pink;
                padding: 50px 0 100px;

                .title {
                    font-size: 28px;
                    font-weight: 600;
                }

                .time {
                    color: #999;
                }

                .start {
                    font-size: 16px;
                    margin: 20px 0;
                    text-indent: 30px;
                    line-height: 28px;
                }

                .banner {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;

                    img {
                        width: 100%;
                        max-width: 660px;
                        height: auto;
                    }
                }

                .list {
                    margin: 20px 0;

                    .list-t {
                        font-size: 18px;
                        font-weight: 600;
                        margin: 16px 0;
                    }

                    .list-text {
                        text-indent: 30px;
                        line-height: 28px;
                    }
                }

                .end {
                    text-indent: 30px;
                    margin-top: 50px;
                    line-height: 28px;
                }
            }
        }

        .btn {
            width: 219px;
            height: 61px;
            background: linear-gradient(129deg, #42f1c9 0%, #2bbda0 100%);
            margin: 0 auto 40px;
            border-radius: 31px;
            color: #fff;
            font-weight: 600;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
                margin-left: 10px;
            }
        }
    }

    &-mobile {
        .news {
            min-width: 100%;

            &.padding-top {
                padding-top: 50px;
            }

            .main {
                width: 100%;

                .back {
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    cursor: pointer;
                    border-bottom: 1px solid #eee;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    background: #fff;

                    &::before {
                        position: absolute;
                        top: 48%;
                        left: 8px;
                        content: "";
                        width: 6px;
                        height: 6px;
                        border-left: 2px solid #666;
                        border-bottom: 2px solid #666;
                        transform: rotate(45deg) translateY(-50%);
                    }

                    span {
                        color: #666;
                        font-size: 14px;
                    }
                }

                .news-box {
                    // padding: 100px 0;
                    // display: flex;
                    // justify-content: center;
                    // background: pink;
                    padding: 50px 20px 100px;

                    .title {
                        font-size: 24px;
                        font-weight: 600;
                    }

                    .time {
                        color: #999;
                        font-size: 14px;
                    }

                    .start {
                        font-size: 16px;
                        margin: 20px 0;
                        text-indent: 30px;
                        line-height: 28px;
                    }

                    .banner {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;

                        img {
                            width: 100%;
                        }
                    }

                    .list {
                        margin: 20px 0;

                        .list-t {
                            font-size: 16px;
                            font-weight: 600;
                            margin: 16px 0;
                        }

                        .list-text {
                            text-indent: 30px;
                            line-height: 28px;
                            font-size: 14px;
                        }
                    }

                    .end {
                        text-indent: 30px;
                        margin-top: 50px;
                        line-height: 28px;
                        font-size: 14px;
                    }
                }
            }

            .btn {
                width: 160px;
                height: 40px;
                font-size: 14px;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/newsInfo/newsInfo237.vue